import "./styles.scss";

import React from "react";
import { Link } from "gatsby";

const SiteLogo = ({ isLight }) => {
  return (
    <Link className="site-logo" to="/">
      <img
        src={
          require(`assets/images/logo/swg--${isLight ? "light" : "dark"}.svg`)
            .default
        }
        alt="Spokój w Głowie"
      />
    </Link>
  );
};

export default SiteLogo;
